import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
	// for footer component to be fixed at the bottom
	mainContainer: {
		position: 'relative',
		minHeight: '96vh',
	}
});
